import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ExternalLink, LogOut } from "lucide-react";
import { api } from "../lib/api";
import { Logo } from "../components/Logo";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { ProjectsTab } from "./ProjectsTab";
import { EnquiriesTab } from "./EnquiriesTab";
import { ServicesTab, FounderTab, ContactTab } from "./SettingsTabs";
import { PaymentsTab } from "./PaymentsTab";

const TABS = [
  ["enquiries", "Enquiries", EnquiriesTab],
  ["projects", "Portfolio", ProjectsTab],
  ["services", "Services & Packages", ServicesTab],
  ["founder", "Founder", FounderTab],
  ["contact", "Contact & Social", ContactTab],
  ["payments", "Payments", PaymentsTab],
];

export default function AdminDashboard() {
  const nav = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    document.title = "Dashboard — BWI Studio";
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => nav("/studio-admin"));
  }, [nav]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    nav("/studio-admin");
  };

  if (!user) return <div className="min-h-screen bg-sand" />;

  return (
    <div className="min-h-screen bg-sand" data-testid="admin-dashboard">
      <header className="border-b border-line bg-ivory">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4">
          <Logo />
          <div className="flex items-center gap-5 text-sm">
            <Link to="/" target="_blank" className="hidden items-center gap-1.5 text-wine hover:underline sm:flex" data-testid="admin-view-site"><ExternalLink size={14} /> View site</Link>
            <button onClick={logout} className="flex items-center gap-1.5 text-charcoal/80 hover:text-wine" data-testid="admin-logout-btn"><LogOut size={14} /> Sign out</button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-5 py-10">
        <h1 className="font-serif text-4xl text-wine">Welcome back.</h1>
        <p className="mt-2 text-sm text-muted-ink">Everything you change here appears on the website straight away.</p>
        <Tabs defaultValue="enquiries" className="mt-8">
          <div className="-mx-5 overflow-x-auto px-5">
            <TabsList className="h-auto w-max gap-1 rounded-none bg-transparent p-0">
              {TABS.map(([k, label]) => (
                <TabsTrigger key={k} value={k} data-testid={`admin-tab-${k}`} className="rounded-none border border-transparent px-4 py-2.5 text-xs uppercase tracking-[0.15em] data-[state=active]:border-line data-[state=active]:bg-ivory data-[state=active]:text-wine data-[state=active]:shadow-none">
                  {label}
                </TabsTrigger>
              ))}
            </TabsList>
          </div>
          {TABS.map(([k, , Comp]) => (
            <TabsContent key={k} value={k} className="mt-6">
              <Comp />
            </TabsContent>
          ))}
        </Tabs>
      </main>
    </div>
  );
}
